import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // { id, username, role }
  const [ready, setReady] = useState(false);

  // Hidratar sesión al cargar
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const r = await fetch('/api/me.php', {
          credentials: 'include',
          cache: 'no-store',
          signal: ac.signal,
        });
        if (r.status === 401) { setUser(null); return; }
        const j = await r.json();
        setUser(j?.authenticated ? j.user : null);
      } catch {
        setUser(null);
  } finally { setReady(true); }})();
    return () => ac.abort();
  }, []);

  // Guardar usuario tras login y revalidar cookie
  const login = async (serverUser) => {
    // serverUser viene de /api/login_user.php: { id, username, role }
    setUser(serverUser || null);
    try {
      const r = await fetch('/api/me.php', { credentials: 'include', cache: 'no-store' });
      const j = await r.json();
      if (j?.authenticated) setUser(j.user);
    } catch {}
  };

  // Cerrar sesión
  const logout = async () => {
    try {
      await fetch('/api/logout.php', { method: 'POST', credentials: 'include', cache: 'no-store' });
    } catch {}
    setUser(null);
  };

  const value = useMemo(() => ({
    user,                         // { id, username, role }
    isLoggedIn: !!user,
    isAdmin: user?.role === 'admin',
    ready,
    login,
    logout,
  }), [user, ready]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  return ctx;
};
